import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Body1 from '../Typography/Body/Body1';
import Headline3 from '../Typography/Heading/Headline3';
import { Breadcrumbs } from '../Breadcrumb';
import { Grid, GridCell } from '../Grid';

export const StyledHeadline3 = styled(Headline3)`
  && {
    text-align: center;
    margin: 32px 16px 16px;
  }
`;

export const StyledBody1 = styled(Body1)`
  && {
    text-align: center;
    margin: 0 16px 32px;
  }
`;

const eventsPagePropertyTypes = {
  title: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.arrayOf(PropTypes.node).isRequired,
  description: PropTypes.string.isRequired,
  children: PropTypes.node,
};

type EventsPageProperties = InferProps<typeof eventsPagePropertyTypes>;

const EventsPage = ({
  breadcrumbs,
  title,
  description,
  children,
}: EventsPageProperties) => (
  <Grid>
    <GridCell padding="0 24px">
      <Breadcrumbs
        crumbs={breadcrumbs}
      />
    </GridCell>
    <GridCell padding="0 20px">
      <StyledHeadline3 tag="h1">
        {title}
      </StyledHeadline3>
      <StyledBody1>
        {description}
      </StyledBody1>
      { children }
    </GridCell>
  </Grid>
);

EventsPage.propTypes = eventsPagePropertyTypes;

EventsPage.defaultProps = {
  children: undefined,
};

export default EventsPage;
